module.exports = __webpack_public_path__ + "img/translate-eight.826fd763.png";